import { PayeeContactTabsType } from '@/legacy/services/filters/payeeFilters';
import Filter from '@/legacy/shared/components/SearchFilter/models/Filter';
import {
  Property as FilterProperty,
  PropertyType,
} from '@/legacy/shared/components/SearchFilter/models/Property';

import { Payee } from '../interfaces';
import { Comparison } from '../payeesRestApiService';

import { QueryAction, SortingItem } from './contactsTable.actions';

enum FilterNames {
  Email = 'Email',
  PadStatus = 'PAD Status',
}

enum FilterRelations {
  Equals = 'equals',
  NotEqualTo = 'not equal to',
  Contains = 'contains',
  DoesNotContain = 'does not contain',
  StartsWith = 'starts with',
}

interface State {
  isLoading: boolean;
  isError: boolean;
  searchQuery: string;
  filters: Array<Filter>;
  sorting: Array<SortingItem>;
  data: Array<Payee>;
  totalCount: number;
  grandTotalCount: number;
  currentPage: number;
  pageSizeOptions: Array<number>;
  pageSize: number;
  contactType: PayeeContactTabsType;
  appliedFilters: Array<number>;
  filterOptions: Array<FilterProperty>;
  queries: Array<QueryAction>;
}

function getInitialState(contactType: PayeeContactTabsType): State {
  return {
    isLoading: false,
    isError: false,
    searchQuery: '',
    filters: [],
    sorting: [],
    data: [],
    totalCount: 0,
    grandTotalCount: null,
    currentPage: 0,
    pageSizeOptions: [10, 25, 50],
    pageSize: 10,
    contactType,
    appliedFilters: [],
    filterOptions: [
      {
        name: FilterNames.Email,
        label: FilterNames.Email,
        type: PropertyType.Text,
        relations: [
          { value: Comparison.Equals, label: FilterRelations.Equals },
          { value: Comparison.NotEquals, label: FilterRelations.NotEqualTo },
          { value: Comparison.Contains, label: FilterRelations.Contains },
          { value: Comparison.DoesNotContain, label: FilterRelations.DoesNotContain },
          { value: Comparison.StartsWith, label: FilterRelations.StartsWith },
        ],
      },
      {
        name: FilterNames.PadStatus,
        label: FilterNames.PadStatus,
        type: PropertyType.Dropdown,
        values: [
          { value: '0', label: 'None' },
          { value: '100', label: 'Pending' },
          { value: '200', label: 'Completed' },
        ],
        relations: [
          { value: Comparison.Equals, label: FilterRelations.Equals },
          { value: Comparison.NotEquals, label: FilterRelations.NotEqualTo },
        ],
      },
    ],
    queries: [],
  };
}

export { getInitialState, FilterNames };
export default State;
